import { Label } from "../label";
import {
  TagInput,
  type TagInputProps,
  type TagValidationResult,
} from "../tag-input";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface FormTagInputProps extends Omit<TagInputProps, "value" | "onChange"> {
  label?: string;
  showErrorMessage?: boolean;
}

function FormTagInput({
  label,
  showErrorMessage = true,
  ...props
}: FormTagInputProps) {
  const field = useFieldContext<string[]>();

  return (
    <div className="flex flex-col gap-2">
      {label ? (
        <Label htmlFor={field.name} className="text-sm font-medium">
          {label}
        </Label>
      ) : null}
      <TagInput
        value={field.state.value ?? []}
        onChange={(tags) => field.handleChange(tags)}
        {...props}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormTagInput };
export type { TagValidationResult };
